const CANCEL_LOAN = 'CANCEL_LOAN'

const cancelLoan = loanId => {
  return { loanId, type: CANCEL_LOAN }
}

export { CANCEL_LOAN, cancelLoan }
